import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import { sendTokenToExtension } from "@/helpers/send-to-extension.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { queryClient } from "@/queryClient.ts";
import { useAuthStore } from "@/stores/employee.store.ts";
import {
  autoUpdate,
  flip,
  FloatingPortal,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useFocus,
  useInteractions,
} from "@floating-ui/react";
import { Box, Button, FontAwesomeIcon, Stack } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const RestrictedSidebarUserMenu = () => {
  const { data: employee } = useEmployeeMe();
  const { setToken } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const {
    refs: { setReference, setFloating },
    floatingStyles,
    context,
  } = useFloating({
    placement: "right-end",
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(10), flip(), shift()],
    whileElementsMounted: autoUpdate,
  });

  const click = useClick(context);
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([click, focus, dismiss]);

  const logout = () => {
    queryClient.clear();
    setToken(null);
    sendTokenToExtension(null);
    navigate("/login");
  };

  if (!employee) return null;

  return (
    <>
      {/* Своих отступов нет: меню живёт в слоте `footer` рельса, а вертикальные поля там его. */}
      <Box className={"w-8 h-8 cursor-pointer"} ref={setReference} {...getReferenceProps()}>
        <EmployeeAvatar employee={employee} size={"md"} />
      </Box>
      {isOpen && (
        <FloatingPortal>
          <Box
            ref={setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
            className={"p-(--gap-smd) z-popover"}
          >
            <Stack items={"center"} className={"bg-light rounded-sm shadow-sm w-48 p-2"} gap={"sm"}>
              <Button
                onClick={() => {
                  setIsOpen(false);
                  logout();
                }}
                variant={"menu"}
                leftIcon={<FontAwesomeIcon icon={"fa-light fa-right-from-bracket"} />}
              >
                {t("common:logout")}
              </Button>
            </Stack>
          </Box>
        </FloatingPortal>
      )}
    </>
  );
};
